import PropTypes from 'prop-types';
import React from 'react';

const ReceiptDiscountSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 20}`}
      height={`${height || 20}`}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.60768 16.4167C6.29102 15.6834 7.33268 15.7417 7.93268 16.5417L8.77435 17.6667C9.44935 18.5584 10.541 18.5584 11.216 17.6667L12.0577 16.5417C12.6577 15.7417 13.6993 15.6834 14.3827 16.4167C15.866 18 17.0743 17.475 17.0743 15.2584V5.86669C17.0827 2.50835 16.2993 1.66669 13.1493 1.66669H6.84935C3.69935 1.66669 2.91602 2.50835 2.91602 5.86669V15.25C2.91602 17.475 4.13268 17.9917 5.60768 16.4167Z"
        fill="white"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 10.8333L12.5 5.83331"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12.4961 10.8334H12.5036" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.49607 6.24998H7.50356" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

ReceiptDiscountSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ReceiptDiscountSvg;
